<template>
    <div v-html="'Profile'"/>
</template>

<script>
export default { name: "Profile" };
</script>

<style lang="scss" scoped>
</style>